import * as React from 'react'
import { SVGProps } from 'react'
export const SunIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={42}
    height={42}
    fill="none"
    {...props}
  >
    <path
      fill="#858585"
      d="M21 31.5a10.5 10.5 0 1 1 0-21 10.5 10.5 0 0 1 0 21Zm0-3.5a7 7 0 1 0 0-14 7 7 0 0 0 0 14ZM19.25 1.75h3.5V7h-3.5V1.75Zm0 33.25h3.5v5.25h-3.5V35ZM6.151 8.626 8.626 6.15l3.712 3.712-2.475 2.475-3.712-3.712Zm23.512 23.511 2.474-2.474 3.712 3.711-2.475 2.475-3.712-3.712Zm3.711-25.988 2.475 2.477-3.712 3.712-2.474-2.475 3.711-3.713ZM9.863 29.663l2.475 2.474-3.712 3.712-2.475-2.475 3.712-3.712ZM40.25 19.25v3.5H35v-3.5h5.25ZM7 19.25v3.5H1.75v-3.5H7Z"
    />
  </svg>
)
